import { Link, useParams } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { deptBySlug, DEPARTMENTS } from "@/data/departments";
import { ConfianceHero, Guarantees, SectionTitle, PHONE, PHONE_TEL } from "@/components/confiance/ConfianceTop";
import { Specialties } from "@/components/confiance/ConfianceMiddle";
import { WHATSAPP_URL } from "@/lib/whatsapp";
import NotFoundPage from "@/pages/NotFoundPage";

const Cities = ({ dept }) => (
  <section className="bg-slate-50" data-testid="dept-cities">
    <div className="max-w-6xl mx-auto px-5 py-16">
      <SectionTitle kicker={`${dept.name} (${dept.code})`} title={`Nous assurons les professionnels ${dept.article}`} />
      <p className="text-slate-700 max-w-3xl">{dept.intro}</p>
      <ul className="mt-6 flex flex-wrap gap-2">
        {dept.cities.map((c) => <li key={c} className="rounded-full bg-white border border-slate-200 px-4 py-2 text-sm text-slate-700">{c}</li>)}
      </ul>
    </div>
  </section>
);

const Contact = () => (
  <section className="max-w-6xl mx-auto px-5 py-16" data-testid="dept-contact">
    <SectionTitle kicker="Contact" title="Parlons de votre assurance" />
    <div className="grid gap-3 sm:grid-cols-3">
      <a href={`tel:${PHONE_TEL}`} className="rounded-2xl bg-[#0A1864] text-white p-5 flex items-center gap-3" data-testid="dept-call-btn"><Phone className="w-5 h-5" /> {PHONE}</a>
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="rounded-2xl bg-[#25D366] text-white p-5 flex items-center gap-3" data-testid="dept-whatsapp-btn"><MessageCircle className="w-5 h-5" /> WhatsApp</a>
      <a href="mailto:contact@jyvis-assurances.com" className="rounded-2xl border border-slate-200 p-5 flex items-center gap-3 text-slate-800 break-all" data-testid="dept-email-btn"><Mail className="w-5 h-5 shrink-0" /> contact@jyvis-assurances.com</a>
    </div>
    <p className="mt-6 text-sm text-slate-600 flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Agence : 47 rue Jean Jaurès, 93200 Saint-Denis</p>
    <p className="mt-2 text-sm text-slate-600 flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5 shrink-0" /> Lundi–samedi : 10h–12h30 / 13h30–18h</p>
  </section>
);

const OtherZones = ({ current }) => (
  <footer className="bg-[#0A1864] text-white/70 text-sm" data-testid="dept-footer">
    <div className="max-w-6xl mx-auto px-5 py-8 space-y-4">
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        {DEPARTMENTS.filter((d) => d.code !== current).map((d) => (
          <Link key={d.code} to={`/${d.slug}`} className="hover:text-white" data-testid={`dept-other-${d.code}`}>{d.name} ({d.code})</Link>
        ))}
      </div>
      <p>JyVis Assurances est le nom commercial de LS ASSUR. <Link to="/mentions-legales" className="underline hover:text-white">Mentions légales</Link></p>
    </div>
  </footer>
);

export default function DepartmentPage({ slug }) {
  const params = useParams();
  const dept = deptBySlug(slug || params.slug);
  if (!dept) return <NotFoundPage />;
  return (
    <div className="min-h-screen bg-white" data-testid={`dept-page-${dept.code}`}>
      <ConfianceHero title={`Courtier en assurance ${dept.article} (${dept.code})`} />
      <Cities dept={dept} />
      <Specialties />
      <Guarantees />
      <Contact />
      <OtherZones current={dept.code} />
    </div>
  );
}
